export type Units = "imperial" | "metric";
export interface ShipInputs {
  units: Units; weight: number; l: number; w: number; h: number; divisor: number;
  baseRate: number; perUnit: number; roundUp: boolean; packaging: number; markupPct: number;
}
export const DEFAULT_DIVISOR: Record<Units, number> = { imperial: 139, metric: 5000 };

export function shippingModel(i: ShipInputs) {
  const dimWeight = (i.l * i.w * i.h) / (i.divisor || DEFAULT_DIVISOR[i.units]);
  const raw = Math.max(i.weight, dimWeight);
  // Carriers bill any started pound (or kilo) as a whole one.
  const billable = i.roundUp ? Math.ceil(raw - 1e-9) : raw;
  const carrierCost = i.baseRate + billable * i.perUnit;
  const totalCost = carrierCost + i.packaging;
  return { dimWeight, billable, carrierCost, totalCost, charge: totalCost * (1 + i.markupPct / 100), dimWins: dimWeight > i.weight };
}
